import { render } from "./B2bFiltersProfileParties.vue?vue&type=template&id=2266c9a8&scoped=true&lang=pug"
import script from "./B2bFiltersProfileParties.vue?vue&type=script&lang=js"
export * from "./B2bFiltersProfileParties.vue?vue&type=script&lang=js"

import "./B2bFiltersProfileParties.vue?vue&type=style&index=0&id=2266c9a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2266c9a8"]])

export default __exports__